import axios from "axios";

// Use same-origin API calls so the request always matches whichever hostname
// the user is on (apex, www., emergent.host, preview, etc.). This avoids the
// cross-site + credentialed cookie + redirect fragility that produces opaque
// CORS failures. Fallback to REACT_APP_BACKEND_URL only when it's defined AND
// we're running in a dev/SSR context without window (very rare).
const RUNTIME_ORIGIN =
  typeof window !== "undefined" && window.location && window.location.origin
    ? window.location.origin
    : (process.env.REACT_APP_BACKEND_URL || "");
export const API = `${RUNTIME_ORIGIN}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: 60000, // 60s — prevent frontend hang forever on network stalls
});

// attach token from localStorage as a fallback (some browsers block cross-site cookies)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pms_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Terjadi kesalahan. Coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
